import { PermissionType } from '@core/types/permission-type.type'
import { PermissionsSource } from '@core/types/permissions.source'

export const navigationAdmin = [
  {
    title: 'NAV.CLIENTS',
    icon: 'people_outline',
    permission: PermissionType.ClientSection,
    url: '/admin/clients',
  },
  {
    title: 'NAV_CLIENT.RESELLERS',
    icon: 'person',
    permission: PermissionType.ResellerSection,
    url: '/admin/resellers',
  },
  {
    title: 'NAV.DEVICES',
    icon: 'devices_other',
    permission: PermissionsSource.DEVICE,
    url: '/admin/devices',
  },
  {
    title: 'NAV.ADMIN_TEAM',
    icon: 'people',
    permission: PermissionType.AdminTeamSection,
    url: '/admin/team',
  },
  {
    title: 'NAV.ALERTS',
    icon: 'warning',
    permission: PermissionsSource.ALERTS,
    url: '/admin/alerts',
  },
  {
    title: 'NAV.CONFIGURATION',
    icon: 'settings',
    permission: PermissionsSource.CONFIGURATION,
    url: '/admin/config',
  },
  {
    title: 'NAV.ANALYTICS',
    icon: 'insights',
    permission: PermissionsSource['ANALYTICS.ANALYTICS_VIEW'],
    url: '/admin/analytics',
  },
  {
    title: 'NAV.TOOLS',
    icon: 'build',
    controlAdminOnly: true,
    url: '/admin/tools',
  },
]
